/**
 * Run- and step-status labels + badge tones live in
 * `@wit-support/ui-domain/pipeline-labels`, next to `pipelineStepSummaryRu`,
 * so the rail and the pipeline-runs page cannot drift apart again (they each
 * had a private copy, and both had gone stale — neither knew `waiting`).
 */
/** Format a run's elapsed time: a `durationMs` span for terminal runs, else "—". */
export function formatRunDuration(durationMs) {
    if (durationMs === null)
        return '';
    if (durationMs < 1000)
        return `${durationMs} мс`;
    const secs = durationMs / 1000;
    if (secs < 60)
        return `${secs.toFixed(secs < 10 ? 1 : 0)} с`;
    const mins = Math.floor(secs / 60);
    const rem = Math.round(secs % 60);
    return `${mins} мин ${rem} с`;
}
/**
 * A parked run's «ждём клиента до …» line, shown where a terminal run shows its
 * duration. A `waiting` run has no elapsed span worth printing — the fact an
 * operator acts on is until WHEN the bot keeps waiting before it escalates.
 * Returns '' when the deadline is missing or unparseable, so the row simply
 * shows nothing rather than a broken date.
 */
export function formatWaitDeadline(waitDeadline) {
    if (!waitDeadline)
        return '';
    const d = new Date(waitDeadline);
    if (Number.isNaN(d.getTime()))
        return '';
    return `ждём клиента до ${d.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    })}`;
}
//# sourceMappingURL=format-run.js.map